<script setup lang="ts">
defineProps({
  msg: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div
    class="py-20 my-20 min-h-96 flex flex-col justify-center items-center gap-8"
  >
    <img
      src="/img/no_items.png"
      :alt="$t('main.itemsNotFound.noItemsFound')"
      class="w-10"
    />
    <p class="text-neutral-400">
      {{ msg ?? $t("main.itemsNotFound.noItemsFound") }}
    </p>
  </div>
</template>
